import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconWarningCircle = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 24 24'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M12.000,24.000 C5.383,24.000 -0.000,18.617 -0.000,12.000 C-0.000,5.383 5.383,0.000 12.000,0.000 C18.617,0.000 24.000,5.383 24.000,12.000 C24.000,18.617 18.617,24.000 12.000,24.000 ZM12.000,2.000 C6.486,2.000 2.000,6.486 2.000,12.000 C2.000,17.514 6.486,22.000 12.000,22.000 C17.514,22.000 22.000,17.514 22.000,12.000 C22.000,6.486 17.514,2.000 12.000,2.000 ZM12.000,19.000 C11.740,19.000 11.480,18.890 11.290,18.710 C11.109,18.520 11.000,18.260 11.000,18.000 C11.000,17.730 11.109,17.480 11.290,17.290 C11.660,16.920 12.330,16.920 12.710,17.290 C12.890,17.480 13.000,17.730 13.000,18.000 C13.000,18.260 12.890,18.520 12.710,18.710 C12.520,18.890 12.260,19.000 12.000,19.000 ZM12.000,15.000 C11.447,15.000 11.000,14.552 11.000,14.000 L11.000,6.000 C11.000,5.448 11.447,5.000 12.000,5.000 C12.553,5.000 13.000,5.448 13.000,6.000 L13.000,14.000 C13.000,14.552 12.553,15.000 12.000,15.000 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconWarningCircle.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
